export default __webpack_public_path__ + "static/media/img_12.a0725d74.jpg";